import CryptoJS from 'crypto-js';

const ENCRYPTION_KEY = process.env.ENCRYPTION_KEY || "vkyp2s5v8y/B?E(H+MbQeThWmZq4t6w9"; // 32characters

export const aesEncrypt = function encrypt(text) {
    const iv = CryptoJS.lib.WordArray.random(128/8).toString(CryptoJS.enc.Hex);
    const key = CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY);
    const encrypted = CryptoJS.AES.encrypt(text, key, { iv: CryptoJS.enc.Hex.parse(iv) });
    return `${iv}.${encrypted.ciphertext.toString(CryptoJS.enc.Hex)}`;
}

export const aesDecrypt = function decrypt(text) {
    if (!text) {
        return ('No text provided for decryption');
    }

    const [iv, encryptedText] = text?.split('.');

    if (!iv || !encryptedText) {
        return ('Invalid text format for decryption');
    }

    const key = CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY);

    const cipherParams = CryptoJS.lib.CipherParams.create({
        ciphertext: CryptoJS.enc.Hex.parse(encryptedText)
    });

    const decrypted = CryptoJS.AES.decrypt(cipherParams, key, { iv: CryptoJS.enc.Hex.parse(iv) });

    return decrypted.toString(CryptoJS.enc.Utf8);
}